import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { LuUpload } from "react-icons/lu";
import { AiOutlineClose } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Admin/Header'; // Импортируем Header
import Sidebar from '../components/Admin/Sidebar'; // Импортируем Sidebar

import { $host } from "../http";

const CourseAddPage = () => {
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);

  const [currentCourse, setCurrentCourse] = useState({
    title: '',
    description: '',
    price: '',
    subject: { id: '', name: '' }, // Инициализация subject
  });

  const [errors, setErrors] = useState({
    title: '',
    description: '',
    subject: '',
    image: '',
    teacher: '',
    price: '',
  });

  const [subjects, setSubjects] = useState([]); // Состояние для списка предметов
  const [selectedSubject, setSelectedSubject] = useState(null); // Состояние для выбранного предмета
  const [teachers, setTeachers] = useState([]); // Состояние для списка преподавателей
  const [selectedTeacher, setSelectedTeacher] = useState(null); // Состояние для выбранного преподавателя
  const [searchTerm, setSearchTerm] = useState(''); // Состояние для поиска
  const [isTeacherModalOpen, setTeacherIsModalOpen] = useState(false); // Состояние для управления модальным окном преподавателя
  const [subjectSearchTerm, setSubjectSearchTerm] = useState(''); // Состояние для поиска предметов
  const [isSubjectModalOpen, setIsSubjectModalOpen] = useState(false); // Состояние для управления модальным окном предметов
  const [curators, setCurators] = useState([]); // Состояние для списка кураторов
  const [selectedCurators, setSelectedCurators] = useState([]); // Состояние для выбранных кураторов
  const [isCuratorModalOpen, setIsCuratorModalOpen] = useState(false); // Состояние для модального окна кураторов
  const [curatorSearchTerm, setCuratorSearchTerm] = useState(''); // Состояние для поиска кураторов
  const [coursePrice, setCoursePrice] = useState(currentCourse ? currentCourse.price : ''); // Состояние для хранения цены курса
  const [isPriceApplied, setIsPriceApplied] = useState(false); // Состояние для отслеживания активности кнопки
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  const [courseClass, setCourseClass] = useState(9)

  // Фильтр для предметов
  const filteredSubjects = subjects.filter(subject =>
    subject.title.toLowerCase().includes(subjectSearchTerm.toLowerCase()) &&
    subject.id !== selectedSubject?.id // Убедитесь, что выбранный предмет не отображается
  );

  // Функция для выбора предмета
  const handleSubjectSelection = (subject) => {
    setSelectedSubject(subject);
    setCurrentCourse((prev) => ({
      ...prev,
      subject: { id: subject.id, name: subject.title }, // Обновляем subject с id и названием
    }));
    setIsSubjectModalOpen(false); // Закрываем модальное окно
  };

  // Функция для применения цены
  const handlePriceApply = () => {
    setCurrentCourse((prev) => ({ ...prev, price: coursePrice })); // Сохраняем новую цену в состояние курса
    setIsPriceApplied(true); // Делаем кнопку неактивной
  };

  const handlePriceChange = (e) => {
    setCoursePrice(e.target.value);
    if (isPriceApplied) {
      setIsPriceApplied(false); // Активируем кнопку, если изменился текст
    }
  };

  // Фильтр для кураторов
  const filteredCurators = curators.filter(curator =>
    curator.id.includes(curatorSearchTerm) || curator.email.toLowerCase().includes(curatorSearchTerm.toLowerCase())
  );

  // Функция для добавления/удаления куратора из списка выбранных
  const toggleCuratorSelection = (curator) => {
    setSelectedCurators((prev) => {
      if (prev.includes(curator)) {
        return prev.filter(c => c !== curator); // Удаляем куратора
      }
      return [...prev, curator]; // Добавляем куратора
    });
  };

  // Удаление всех кураторов
  const removeAllCurators = () => {
    setSelectedCurators([]);
  };

  const filteredTeachers = teachers.filter(teacher =>
    (teacher.id.includes(searchTerm) || teacher.email.toLowerCase().includes(searchTerm.toLowerCase())) &&
    teacher.id !== selectedTeacher?.id // Убедитесь, что выбранный преподаватель не отображается
  );

  const handleTeacherSelection = (teacher) => {
    setSelectedTeacher(teacher);
    setTeacherIsModalOpen(false); // Закрываем модальное окно после выбора
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log("Дата начала курса:", e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log("Дата окончания курса:", e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Сбрасываем ошибки
    setErrors({ title: '', description: '', subject: '', image: '', teacher: '', price: '' });

    // Проверяем обязательные поля
    let hasErrors = false;
    if (!currentCourse.title) {
      setErrors(prev => ({ ...prev, title: 'Название курса обязательно' }));
      hasErrors = true;
    }
    if (!currentCourse.description) {
      setErrors(prev => ({ ...prev, description: 'Описание курса обязательно' }));
      hasErrors = true;
    }
    if (!selectedSubject) {
      setErrors(prev => ({ ...prev, subject: 'Предмет обязателен для выбора' }));
      hasErrors = true;
    }
    if (!imageFile) {
      setErrors(prev => ({ ...prev, image: 'Обложка обязательна для загрузки' }));
      hasErrors = true;
    }
    if (!selectedTeacher) {
      setErrors(prev => ({ ...prev, teacher: 'Преподаватель обязателен для выбора' }));
      hasErrors = true;
    }
    if (!coursePrice) {
      setErrors(prev => ({ ...prev, price: 'Цена курса обязательна' }));
      hasErrors = true;
    }
    if (hasErrors) return; // Прекращаем выполнение, если есть ошибки

    const subjectId = selectedSubject ? selectedSubject.id : ''; // Получаем ID предмета из текущего курса, если он существует
    const apiUrl = `/api/admin/courses/create/${subjectId}`;
    const method = 'POST';

    // Создаем объект с данными курса
    const courseData = {
      title: currentCourse.title,
      description: currentCourse.description,
    };
    // Добавление цены курса, если она не пустая
    if (coursePrice) {
      courseData.price = coursePrice;
    }
    // Добавление ID преподавателя, если он выбран
    if (selectedTeacher) {
      courseData.teacher_id = selectedTeacher.id;
    }
    // Проверка состояния предмета и добавление ID, если он выбран
    if (selectedSubject && selectedSubject.id) {
      courseData.subject_id = selectedSubject.id; // Добавляем ID предмета
    }
    // Получаем ID кураторов, если они выбраны
    const curatorIds = selectedCurators.map(curator => curator.id).filter(id => id); // Фильтруем пустые значения

    // Создаем FormData и добавляем данные курса
    const formData = new FormData();
    formData.append('title', courseData.title);
    formData.append('description', courseData.description);
    formData.append('class_course', courseClass)
    if (coursePrice) {
      formData.append('price', courseData.price);
    }
    if (selectedTeacher) {
      formData.append('teacher_id', courseData.teacher_id);
    }
    if (courseData.subject_id) {
      formData.append('subject_id', courseData.subject_id); // Добавляем ID предмета в FormData
    }

    // Добавляем кураторов по отдельности
    if (curatorIds.length > 0) {
      curatorIds.forEach(curatorId => {
        formData.append('curators', curatorId); // Добавляем каждого куратора отдельно
      });
    }

    // Добавляем загруженные файлы, если они есть
    if (imageFile) {
      formData.append('image', imageFile); // Файл обложки
    }
    if (videoFile) {
      formData.append('video', videoFile); // Файл видео
    }

    formData.append('start_date', startDate); // Дата начала курса

    formData.append('end_date', endDate); // Дата окончания курса

    try {
      // Отправляем данные курса и файлы как FormData
      const response = await $host.request(apiUrl, {
        method,
        data: formData, // Отправляем FormData, который содержит и данные курса, и файлы
      });
      console.log("Данные курса успешно отправлены:", formData);
      console.log("Отправляемые данные:");
      console.log("start_date:", startDate);
      console.log("end_date:", endDate);

      navigate('/admin'); // Переадресация на страницу списка курсов
    } catch (error) {
      console.log("Отправляемые даты:", startDate, endDate);

      console.error(error);
    }
  };

  const formatFileSize = (size) => {
    return (size / (1024 * 1024)).toFixed(2) + ' МБ'; // Форматируем размер в мегабайты
  };

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toUpperCase(); // Получаем расширение файла и переводим в верхний регистр
  };

  // Запрос на получение списка предметов
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const { data } = await $host.get('/api/public/subjects');
        setSubjects(data)
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };
    fetchSubjects(); // Вызываем функцию для получения предметов
  }, []);

  // Запрос на получение списка кураторов
  useEffect(() => {
    const fetchCurators = async () => {
      try {
        const response = await $host.get('/api/admin/users/role/curator');
        const { data } = response
        if (data.message === "succses") {
          setCurators(data.body); // Сохраняем массив кураторов в состояние
        } else {
          console.error("Ошибка при получении данных:", data.message);
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };
    fetchCurators();
  }, []);

  // Запрос на получение списка преподавателей
  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await $host('/api/admin/users/role/teacher');
        const { data } = response;
        if (data.message === "succses") {
          setTeachers(data.body); // Сохраняем массив преподавателей в состоянии
        } else {
          console.error("Ошибка при получении данных:", data.message);
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };
    fetchTeachers(); // Вызываем функцию для получения преподавателей
  }, []);


  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex items-center">
              <li>
                <Link to="/admin/courses" className="text-black">Главная</Link>
              </li>
              <li className="mx-2">
                <span className="text-neutral-400">&gt;</span>
              </li>
              <li>
                <Link to="/courses/add" className="text-neutral-400">Создать курс</Link>
              </li>
            </ol>
          </nav>

          <h2 className="text-[42px] font-medium mb-4">Добавление нового курса</h2>

          <div className="bg-white p-6 rounded-lg shadow-md mb-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <form onSubmit={handleSubmit}>
              {/* Название курса */}
              <div className="mb-8 border border-[#6446C314] rounded-[10px] p-2">
                <div className="mb-4 flex items-center justify-between">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title" style={{ color: '#363645', fontSize: '24px', marginRight: '8px' }}>
                    Название курса<span className="text-red-500 ml-1">*</span>
                  </label>
                  <button type="submit" className="h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px]">Добавить курс</button>
                </div>
                <input
                  type="text"
                  id="title"
                  value={currentCourse ? currentCourse.title : ''}
                  onChange={(e) => setCurrentCourse({ ...currentCourse, title: e.target.value })}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                  style={{ backgroundColor: '#6446C314', borderRadius: '8px' }}
                  placeholder="Введите название курса"
                />
                {errors.title && <span className="text-red-500 text-[16px]">{errors.title}</span>}
              </div>

              {/* Описание курса */}
              <div className="mb-8 border border-[#6446C314] rounded-[10px] p-2">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description" style={{ color: '#363645', fontSize: '24px', marginRight: '8px' }}>
                  Описание курса<span className="text-red-500 ml-1">*</span>
                </label>
                <textarea
                  id="description"
                  value={currentCourse ? currentCourse.description : ''}
                  onChange={(e) => setCurrentCourse({ ...currentCourse, description: e.target.value })}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                  style={{ backgroundColor: '#6446C314', height: '140px', borderRadius: '8px' }}
                  placeholder="Введите описание курса"
                />
                {errors.description && <span className="text-red-500 text-[16px]">{errors.description}</span>}
              </div>

              {/* Загрузка обложки и видео */}
              <div className="flex items-center mb-2 border border-[#6446C314] rounded-[10px] p-2">
                {/* Загрузка обложки */}
                {imageFile ? (
                  <div className="flex items-center mr-2">
                    <LuUpload style={{ color: '#6446C3', fontSize: '24px', marginRight: '8px' }} />
                    <div>
                      <div className="text-[#6446C3] mb-2" style={{ fontSize: '16px' }}>Обложка</div>
                      <div className="text-[#6446C399] font-normal" style={{ fontSize: '12px' }}>
                        {getFileExtension(imageFile.name)} - файл, {formatFileSize(imageFile.size)}
                      </div>
                    </div>
                    <button onClick={() => setImageFile(null)} className="ml-2 text-red-600 hover:text-red-800 focus:outline-none">Удалить</button>
                  </div>
                ) : (
                  <label className="border-2 border-dashed border-[#6446C3] rounded-md py-2 px-4 mr-2 cursor-pointer">
                    Загрузить обложку
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setImageFile(e.target.files[0])}
                      className="hidden"
                    />
                  </label>
                )}
                {/* Загрузка видео */}
                {videoFile ? (
                  <div className="flex items-center ml-2">
                    <LuUpload style={{ color: '#6446C3', fontSize: '24px', marginRight: '8px' }} />
                    <div>
                      <div className="text-[#6446C3] mb-2" style={{ fontSize: '16px' }}>Видео</div>
                      <div className="text-[#6446C399] font-normal" style={{ fontSize: '12px' }}>
                        {getFileExtension(videoFile.name)} - файл, {formatFileSize(videoFile.size)}
                      </div>
                    </div>
                    <button onClick={() => setVideoFile(null)} className="ml-2 text-red-600 hover:text-red-800 focus:outline-none">Удалить</button>
                  </div>
                ) : (
                  <label className="border-2 border-dashed border-[#6446C3] rounded-md py-2 px-4 cursor-pointer ml-4">
                    Загрузить видео
                    <input
                      type="file"
                      accept="video/*"
                      onChange={(e) => setVideoFile(e.target.files[0])}
                      className="hidden"
                    />
                  </label>
                )}
              </div>
              {errors.image && <span className="text-red-500 text-[16px]">{errors.image}</span>}

              {/* Предмет */}
              <div className="mt-8 mb-4 flex flex-col border border-[#6446C314] rounded-[10px] p-2">
                <label className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px', marginRight: '8px' }}>
                  Предмет<span className="text-red-500 ml-1">*</span>
                </label>
                <span className="pl-0 border border-gray-300 p-2 rounded text-[#6446C3] mb-2">{selectedSubject ? selectedSubject.title : 'Не выбран'}</span>
                <button type="button" className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px] mb-2" onClick={() => setIsSubjectModalOpen(true)}>
                  Выбрать предмет
                </button>
                {errors.subject && <span className="text-red-500 text-[16px]">{errors.subject}</span>}
              </div>

              {/* Модальное окно для выбора предмета */}
              {isSubjectModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white rounded-lg p-8 w-[60%] relative">
                    <h2 className="text-lg font-bold mb-4">Выбор предмета</h2>
                    <button onClick={() => setIsSubjectModalOpen(false)} className="absolute top-4 right-4 text-gray-600 hover:text-gray-800">
                      <AiOutlineClose size={24} />
                    </button>
                    <div className="relative mb-4">
                      <FaSearch className="weight-900 absolute left-3 top-2.5 text-[#6446C399]" size={20} />
                      <input
                        type="text"
                        placeholder="Введите название или ID предмета"
                        value={subjectSearchTerm}
                        onChange={(e) => setSubjectSearchTerm(e.target.value)}
                        className="border rounded-[16px] p-2 w-full pl-10"
                        style={{ backgroundColor: "#6446C314", color: "#6446C399" }}
                      />
                    </div>
                    <div className="mb-2">
                      <span className="text-gray-500 ml-1">*</span>
                      <label className="font-normal text-gray-500">Выберите предмет с помощью двойного клика:</label>
                    </div>
                    <div className="overflow-auto max-h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}
                      <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
                        <thead style={{ borderBottom: "1px solid #D1D5DB", color: "#6446C3" }}>
                          <tr>
                            <th className="border px-4 py-2 text-left">№</th>
                            <th className="border px-4 py-2 text-left">Название</th>
                            <th className="border px-4 py-2 text-left">ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredSubjects.length > 0 ? (
                            filteredSubjects.map((subject, index) => (
                              <tr key={subject.id} onDoubleClick={() => handleSubjectSelection(subject)} className="cursor-pointer hover:bg-gray-200">
                                <td className="border px-4 py-2 text-left">{index + 1}</td>
                                <td className="border px-4 py-2 text-left">{subject.title}</td>
                                <td className="border px-4 py-2 text-left">{subject.id}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="border px-4 py-2" colSpan={3}>Нет предметов</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Преподаватель */}
              <div className="mt-8 mb-4 flex flex-col border border-[#6446C314] rounded-[10px] p-2">
                <label className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px' }}>
                  Преподаватель:<span className="text-red-500 ml-1">*</span>
                </label>
                <span className="pl-0 border border-gray-300 p-2 rounded text-[#6446C3] mb-2">{selectedTeacher ? selectedTeacher.email : 'Не выбран'}</span>
                <button type="button" className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px] mb-2" onClick={() => setTeacherIsModalOpen(true)}>
                  Выбрать преподавателя
                </button>
                {errors.teacher && <span className="text-red-500 text-[16px]">{errors.teacher}</span>}
              </div>

              {/* Модальное окно для выбора преподавателя */}
              {isTeacherModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white rounded-lg p-8 w-[60%] relative">
                    <h2 className="text-lg font-bold mb-4">Выбор преподавателя</h2>
                    <button onClick={() => setTeacherIsModalOpen(false)} className="absolute top-4 right-4 text-gray-600 hover:text-gray-800">
                      <AiOutlineClose size={24} />
                    </button>
                    <div className="relative mb-4">
                      <FaSearch className="weight-900 absolute left-3 top-2.5 text-[#6446C399]" size={20} />
                      <input
                        type="text"
                        placeholder="Введите email, ФИО или ID преподавателя"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="border rounded-[16px] p-2 w-full pl-10 mb-4"
                        style={{ backgroundColor: '#6446C314', color: '#6446C399' }}
                      />
                    </div>
                    <div className="mb-2">
                      <span className="text-gray-500 ml-1">*</span>
                      <label className="font-normal text-gray-500">Выберите преподавателя с помощью двойного клика:</label>
                    </div>
                    <div className="overflow-auto max-h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}
                      <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
                        <thead style={{ borderBottom: '1px solid #D1D5DB', color: '#6446C3' }}>
                          <tr>
                            <th className="border px-4 py-2 text-left">№</th>
                            <th className="border px-4 py-2 text-left">Email</th>
                            <th className="border px-4 py-2 text-left">ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTeachers.length > 0 ? (
                            filteredTeachers.map((teacher, index) => (
                              <tr key={teacher.id} onDoubleClick={() => handleTeacherSelection(teacher)} className="cursor-pointer hover:bg-gray-200">
                                <td className="border px-4 py-2 text-left">{index + 1}</td>
                                <td className="border px-4 py-2 text-left">{teacher.email}</td>
                                <td className="border px-4 py-2 text-left">{teacher.id}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="border px-4 py-2" colSpan={3}>Нет преподавателей</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Наставничество */}
              <div className="mt-8 mb-2 flex flex-col border border-[#6446C314] rounded-[10px] p-2">
                <span className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px' }}>
                  Наставничество:
                </span>
                <div className="flex items-center">
                  {selectedCurators.length > 0 && <span className="text-[#6446C3] font-normal mr-4">{selectedCurators.length} наставников</span>}
                  <button type="button" className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px]" onClick={() => setIsCuratorModalOpen(true)}>
                    Настроить
                  </button>
                </div>
              </div>

              {/* Модальное окно для выбора кураторов */}
              {isCuratorModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white rounded-lg p-8 w-[60%] relative">
                    <h2 className="text-lg font-bold mb-4">Выбор кураторов</h2>
                    <button onClick={() => setIsCuratorModalOpen(false)} className="absolute top-4 right-4 text-gray-600 hover:text-gray-800">
                      <AiOutlineClose size={24} />
                    </button>
                    <div className="relative mb-4">
                      <FaSearch className="weight-900 absolute left-3 top-2.5 text-[#6446C399]" size={20} />
                      <input
                        type="text"
                        placeholder="Введите email, ФИО или ID наставника"
                        value={curatorSearchTerm}
                        onChange={(e) => setCuratorSearchTerm(e.target.value)}
                        className="border rounded-[16px] p-2 w-full pl-10 mb-4"
                        style={{ backgroundColor: '#6446C314', color: '#6446C399' }}
                      />
                    </div>
                    <div className="overflow-auto max-h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}
                      <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
                        <thead style={{ borderBottom: '1px solid #D1D5DB', color: '#6446C3' }}>
                          <tr>
                            <th className="border px-4 py-2 text-left">№</th>
                            <th className="border px-4 py-2 text-left">Email</th>
                            <th className="border px-4 py-2 text-left">ID</th>
                            <th className="border px-4 py-2 text-left"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCurators.length > 0 ? (
                            filteredCurators.map((curator, index) => (
                              <tr key={curator.id} className="hover:bg-gray-200">
                                <td className="border px-4 py-2 text-left">{index + 1}</td>
                                <td className="border px-4 py-2 text-left">{curator.email}</td>
                                <td className="border px-4 py-2 text-left">{curator.id}</td>
                                <td className="border px-4 py-2 text-left">
                                  <button
                                    type="button"
                                    onClick={() => toggleCuratorSelection(curator)}
                                    className={`py-2 px-4 rounded-[8px] ${selectedCurators.includes(curator) ? 'bg-[#6446C314] text-[#6446C3]' : 'bg-[#6446C3] text-white'} transition duration-200 ease-in-out hover:bg-[#6446C314] text-[12px] font-normal`}
                                  >
                                    {selectedCurators.includes(curator) ? 'Отмена' : 'Добавить'}
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="border px-4 py-2" colSpan={4}>Нет кураторов</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="flex mt-4">
                      <button type="button" onClick={removeAllCurators} className="rounded-[10px] bg-red-500 text-white p-2">Удалить всех</button>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-8 mb-4 flex flex-col border border-[#6446C314] rounded-[10px] p-2">
                <span className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px' }}>
                  Класс:<span className="text-red-500 ml-1">*</span>
                </span>
                <div className="flex gap-4 mt-2">
                  <label className="checkout-panel__agreement">
                    <input
                      type="checkbox"
                      checked={courseClass === 9}
                      onChange={(e) => setCourseClass(9)}
                    />
                    <p>
                      <span>9 класс (ОГЭ) </span>
                    </p>
                  </label>
                  <label className="checkout-panel__agreement">
                    <input
                      type="checkbox"
                      checked={courseClass === 11}
                      onChange={(e) => setCourseClass(11)}
                    />
                    <p>
                      <span>11 класс (ЕГЭ) </span>
                    </p>
                  </label>
                </div>
              </div>
              <div className="data-course flex flex-col gap-3 p-3 border border-[#6446C314] rounded-[10px] bg-[#F3F1FB4D]">
                <label className="text-[18px] font-semibold text-[#363645] flex flex-col gap-1">
                  Дата начала курса:
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full max-w-[250px] p-2 border border-[#6446C3] rounded-[8px] bg-[#6446C314] text-[#6446C3] text-[16px] focus:outline-none focus:border-[#4A2CA3] focus:bg-[#ECE6FF]"
                  />
                </label>
                {errors.startDate && <span className="text-[14px] text-red-500">{errors.startDate}</span>}

                <label className="text-[18px] font-semibold text-[#363645] flex flex-col gap-1">
                  Дата окончания курса:
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full max-w-[250px] p-2 border border-[#6446C3] rounded-[8px] bg-[#6446C314] text-[#6446C3] text-[16px] focus:outline-none focus:border-[#4A2CA3] focus:bg-[#ECE6FF]"
                  />
                </label>
                {errors.endDate && <span className="text-[14px] text-red-500">{errors.endDate}</span>}
              </div>

              <div
                className="mt-8 mb-2 flex flex-col"
                style={{
                  border: '1.5px solid #6446C314',
                  borderRadius: '10px',
                  padding: '7px' // Добавлены внутренние отступы
                }}
              >
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="price"
                  style={{
                    color: '#363645',
                    fontSize: '24px',
                    marginRight: '8px',
                  }}
                >
                  Цена курса
                  <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}

                </label>

                <div className="relative">
                  <div className="flex items-center mb-2">
                    <input
                      type="text"
                      id="price"
                      value={coursePrice}
                      onChange={handlePriceChange} // Устанавливаем состояние цены
                      className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full max-w-[350px] h-[42px] pl-4 pr-16 text-[#6446C3]" // Добавляем padding для кнопки
                      placeholder="Введите цену курса"

                    />
                    <button
                      type="button"
                      onClick={handlePriceApply}
                      className={`bg-[#6446C3] text-white rounded-[8px] px-2 py-2 h-[32px] ml-[-110px] ${isPriceApplied ? 'bg-gray-400 text-gray-200' : 'bg-[#6446C3] text-white'}`} // Изменяем цвет кнопки
                      disabled={isPriceApplied} // Делаем кнопку неактивной, если цена применена
                    >
                      Применить
                    </button>
                  </div>
                  {errors.price && <span className="mt-2 text-red-500 text-[16px]">{errors.price}</span>} {/* Ошибка для цены */}

                </div>


              </div>

            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CourseAddPage;
